export {mergeRefs} from '../src/utils/mergeRefs';
